import deepmerge from 'deepmerge'

import { getPersistedState } from '@/logic/statePersisting'

const defaultState = {
  advertisements: null,
}

const persistedState = getPersistedState('advertisements')

export default deepmerge(defaultState, persistedState)
